import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { content } from 'src/environments/data';
import { isHybridShell, requestNativeHybridSignOut } from './shared/hybrid-shell';

/**
 * Hybrid WebViews only: require ddnsession for guarded routes.
 * Browser (no window.Android) is unchanged.
 * Unsigned hybrid → native voice gate (onSignOut), not SPA /login.
 */
@Injectable({
  providedIn: 'root',
})
export class HybridAuthGuard implements CanActivate {
  private readonly loginPath = content.WEBDDN_LOGIN_PATH;

  constructor(
    private cookieService: CookieService,
    private router: Router
  ) {}

  canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (!isHybridShell()) {
      return true;
    }

    const sessionToken = this.cookieService.get('ddnsession');
    if (sessionToken) {
      return true;
    }

    // iOS/Android/Windows: bounce to native voice login instead of Angular /login.
    if (requestNativeHybridSignOut()) {
      return false;
    }

    this.router.navigate([this.loginPath], {
      queryParams: { returnUrl: state.url || '/' },
    });
    return false;
  }
}

/**
 * Modern Functional Route Guard for Angular 22
 */
export const hybridAuthGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  return inject(HybridAuthGuard).canActivate(route, state);
};
